import axios from 'axios';

import * as utils from '../utils/utils.js';

export const fetchGathering = async (gathering_id) => {
    var session_url =
        utils.backendUrl() + `/gathering/?gathering_id=${gathering_id}`;
    try {
        const response = await axios.get(session_url, {
            gathering_id: gathering_id,
            headers: {
                'Content-Type': 'application/json',
            },
        });
        return response.data.gathering;
    } catch (err) {
        console.log(err.message);
        console.log(err.response);
        throw err;
    }
};
